module.exports = __webpack_public_path__ + "img/product-flyer-with-envelope-2.119cf7b8.svg";